import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import ContentModule from "../../modules/content_module";

import "./PackageOption.scss";
import { indexOf } from "lodash";

const PackageOption = ({Module, GQLPage, setPackageOption, package_option}) => {

    return (
        <React.Fragment>
            <section className="pacakge_wrapper" id={Module.id}>
                <Container>
                    <Row>
                        <Col>
                            <div className="package_heading">
                                <h3>{Module?.title}</h3>
                                <p>{Module?.content}</p>
                            </div>

                            {Module?.package_module?.length > 0 &&
                            <div className="pacakge_inner">
                                {Module?.package_module?.map((item, index) => {
                                    return(
                                        <div className="pacakge_box">
                                            <h4>
                                                <label><input type="radio" value={item.title+" - £"+item.landlord_price} name="package_option" onChange={(e) => setPackageOption(e.target.value)} /></label>
                                                {item.title}
                                            </h4>
                                            <div className="pacakge_box_content">
                                                {item?.content && <ContentModule Content={item?.content} /> }
                                                <p>
                                                    Total: £{item.total_price}<br />
                                                    <span>Discount: £{item.discount_price}</span><br />
                                                    Landlord Price: £{item.landlord_price}
                                                </p>
                                            </div>                                        
                                        </div>
                                    )
                                })
                                }
                            </div>
                            }
                        </Col>
                    </Row>
                </Container>
            </section>

        </React.Fragment>
    );
};
export default PackageOption;